import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';

type AppProps = {
  layout?: string;
};
export const App = styled.div<AppProps>`
  ${props =>
    props.layout === 'raw-mobile' &&
    css`
      .header,
      .header--fixed-margin,
      .pj-footer,
      .pj-ui-breadcrumb {
        display: none;
      }
    `};
`;

export const Main = styled.section`
  min-height: calc(100vh - 390px);

  ${media.mediumUp`
    display: flex;
    flex-direction: row;

    @supports (display: grid) {
      display: grid;
      grid-template-columns: auto 1fr; 
    }
  `}
`;

export const Content = styled.div`
  width: 100%;

  ${media.mediumDown`
    max-width: 100vw;
  `};
`;
